import React, { useEffect, useRef } from "react";
import { motion, Variants } from "framer-motion";
import "./css/Banner.css";
import bannerPlaya from "../../img/bannerPlaya.JPEG";
import 'bootstrap/dist/css/bootstrap.css';
import { animate, splitText, stagger } from "animejs";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";

const bannerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 1, ease: "easeOut" },
  },
};

const Banner: React.FC = () => {
    const titleRef = useRef<HTMLHeadingElement | null>(null);
    const { authReady } = useSelector((state: RootState) => state.auth);
    // const hasAnimated = useRef(false);

    useEffect(() => {
        if (!authReady || !titleRef.current) return;

        /* IMPLEMENTAR hasAnimated SI SE QUIERE QUE SE EJECUTE SOLO UNA VEZ AL ENTRAR A LA WEB */
        // if (!authReady || !titleRef.current || hasAnimated.current) return;
        // hasAnimated.current = true;

        const { chars } = splitText(titleRef.current, {
            words: false,
            chars: true,
        });

        const animation = animate(chars, {
            y: [
                { to: "-2.75rem", ease: "outExpo", duration: 600 },
                { to: 0, ease: "outBounce", duration: 800, delay: 100 },
            ],
            rotate: {
                from: "-1turn",
            },
            delay: stagger(50),
            ease: "inOutCirc",
            loop: false,
        });

        return () => {
            animation.pause();
        };

    }, [authReady]);

    return (
        <motion.div className="banner" initial="hidden" animate="visible" variants={bannerVariants}>
            <img src={bannerPlaya} alt="Banner" className="banner-img" />
            <div className="banner-overlay"></div>

            <div className="banner-text-container">
                <h2 className="banner-title" ref={titleRef}>MORRIS Y LUNA</h2>
                <p className="banner-slogan">Nuestro rincón, nuestras aventuras.</p>
            </div>
        </motion.div>
    );
};

export default Banner;
